import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth, useRoleLabel } from "../lib/auth";
import api from "../lib/api";
import { useState, useEffect, useCallback, Fragment } from "react";
import {
  LayoutDashboard, Users, ShoppingCart, FileCheck, CreditCard,
  Boxes, BarChart3, Scale, Bell, UserCog, LogOut, Pizza, Receipt, BookOpenCheck,
  Truck, TrendingUp, Tag, History, Wallet, Layers, PlayCircle, ShieldCheck, FileLock2,
  ClipboardList, ReceiptText, LayoutGrid, Settings2, ListChecks, Shuffle,
  TrendingDown, CalendarCheck2, Banknote, ChartLine, Settings, Building2,
  FileText, Shield, UserSquare2, UserMinus2, Briefcase, Calendar, HeartHandshake, SprayCan, BookOpen, Wrench, DownloadCloud, Coins,
  Sparkles, Wand2, Landmark, Target, ClipboardEdit, SearchX, Store, ToggleRight, Inbox, ShieldAlert,
  Trash2,   // Fix WH42 (2026-09-09): merma
  FileArchive,   // Fix WH89 (2026-10-28): código fuente
} from "lucide-react";
import { motion } from "framer-motion";

function buildComprasNav(t) {
  return {
    corporate_admin: [
      { to: "/dashboard", label: t("nav.dashboard"), icon: LayoutDashboard },
      { to: "/proveedores", label: t("nav.suppliers"), icon: Users },
      { to: "/ocs", label: t("nav.purchaseOrders"), icon: ShoppingCart },
      { to: "/recepciones", label: t("nav.receptions"), icon: Truck },
      { to: "/facturas", label: t("nav.invoices"), icon: FileCheck },
      { to: "/pagos", label: t("nav.payments"), icon: CreditCard },
      { to: "/gastos", label: t("nav.operatingExpenses"), icon: Wallet },
      { to: "/cambios-precios", label: t("nav.priceChanges"), icon: TrendingUp },
      { to: "/auditoria-precios", label: t("nav.priceAudit"), icon: History },
      { to: "/estado-cuenta", label: t("nav.accountStatements"), icon: BookOpenCheck },
      { to: "/inventario", label: t("nav.inventory"), icon: Boxes },
      { to: "/inventario/diario", label: "Inventario diario", icon: Boxes },
      // Fix WH49 (2026-09-17): pedido de Cristian — venta real x receta = insumos
      // consumidos, con el stock de Wansoft al lado.
      { to: "/inventario/consumo", label: "Consumo de insumos", icon: Boxes },
      { to: "/comparador", label: t("nav.priceComparator"), icon: Scale },
      { to: "/reportes", label: t("nav.reports"), icon: BarChart3 },
      { to: "/alertas", label: t("nav.alerts"), icon: Bell },
      { to: "/usuarios", label: t("nav.users"), icon: UserCog },
      { to: "/centros-costo", label: t("nav.costCenters"), icon: Layers },
      { to: "/admin/aviso-privacidad", label: t("nav.privacyNotice"), icon: FileLock2 },
      { to: "/admin/codigo-conducta", label: "Código de Conducta", icon: BookOpen },
      { to: "/admin/migration", label: "Migración de cuenta", icon: DownloadCloud },
      { to: "/admin/sucursales", label: "Sucursales", icon: Store },
      { to: "/admin/system-flags", label: "Flags del sistema", icon: ToggleRight },
      { to: "/admin/codigo-fuente", label: "Código fuente", icon: FileArchive },
      { to: "/perfil/seguridad", label: t("nav.security"), icon: ShieldCheck },
    ],
    branch_manager: [
      { to: "/dashboard", label: t("nav.dashboard"), icon: LayoutDashboard },
      { to: "/ocs", label: t("nav.purchaseOrders"), icon: ShoppingCart },
      { to: "/recepciones", label: t("nav.receptions"), icon: Truck },
      { to: "/gastos", label: t("nav.operatingExpenses"), icon: Wallet },
      { to: "/inventario", label: t("nav.inventory"), icon: Boxes },
      { to: "/inventario/diario", label: "Inventario diario", icon: Boxes },
      { to: "/comparador", label: t("nav.priceComparator"), icon: Scale },
      { to: "/alertas", label: t("nav.alerts"), icon: Bell },
      { to: "/perfil/seguridad", label: t("nav.security"), icon: ShieldCheck },
    ],
    treasury: [
      { to: "/dashboard", label: t("nav.dashboard"), icon: LayoutDashboard },
      // Fix WH46 (2026-09-11): pedido de tesoreria y contabilidad — "no les deja
      // ver las ordenes de compra para identificar diferencias entre lo pedido,
      // lo entregado y la factura".
      //
      // No era que no las dejara: el backend ya les respondia. Ni GET
      // /purchase-orders ni GET /purchase-orders/{id} restringen a tesoreria, y
      // el detalle de la OC ya trae las dos comparaciones que piden —la tabla de
      // pedido contra recibido con la diferencia por producto, y la tarjeta de
      // factura contra OC con la diferencia en pesos y en porcentaje—. Lo unico
      // que faltaba era este renglon en el menu: la pantalla existia y no tenian
      // como llegar.
      { to: "/ocs", label: t("nav.purchaseOrders"), icon: ShoppingCart },
      { to: "/facturas", label: t("nav.invoices"), icon: FileCheck },
      { to: "/pagos", label: t("nav.payments"), icon: CreditCard },
      { to: "/gastos", label: t("nav.operatingExpenses"), icon: Wallet },
      { to: "/estado-cuenta", label: t("nav.accountStatements"), icon: BookOpenCheck },
      // Fix WH49 (2026-09-17): pedido de Cristian — venta real x receta = insumos
      // consumidos, con el stock de Wansoft al lado.
      { to: "/inventario/consumo", label: "Consumo de insumos", icon: Boxes },
      { to: "/reportes", label: t("nav.reports"), icon: BarChart3 },
      { to: "/alertas", label: t("nav.alerts"), icon: Bell },
      { to: "/perfil/seguridad", label: t("nav.security"), icon: ShieldCheck },
    ],
    supplier: [
      { to: "/dashboard", label: t("nav.home"), icon: LayoutDashboard },
      { to: "/ocs", label: t("nav.myPos"), icon: ShoppingCart },
      { to: "/facturas", label: t("nav.myInvoices"), icon: FileCheck },
      { to: "/comprobantes", label: t("nav.receipts"), icon: Receipt },
      { to: "/mis-precios", label: t("nav.myPrices"), icon: Tag },
      { to: "/cambios-precios", label: t("nav.priceChanges"), icon: TrendingUp },
      { to: "/perfil/seguridad", label: t("nav.security"), icon: ShieldCheck },
    ],
    legal: [
      { to: "/proveedores", label: t("nav.legalReview"), icon: Scale },
      { to: "/admin/aviso-privacidad", label: t("nav.privacyNotice"), icon: FileLock2 },
      { to: "/admin/codigo-conducta", label: "Código de Conducta", icon: BookOpen },
      { to: "/alertas", label: t("nav.alerts"), icon: Bell },
      { to: "/perfil/seguridad", label: t("nav.security"), icon: ShieldCheck },
    ],
    direccion: [
      { to: "/ocs", label: "Compras externas pendientes", icon: ShoppingCart },
      // Fix WH49 (2026-09-17): pedido de Cristian — venta real x receta = insumos
      // consumidos, con el stock de Wansoft al lado.
      { to: "/inventario/consumo", label: "Consumo de insumos", icon: Boxes },
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench },
      { to: "/alertas", label: "Alertas", icon: Bell },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    sistemas: [
      { to: "/usuarios", label: t("nav.users"), icon: UserCog },
      { to: "/ocs", label: t("nav.purchaseOrders"), icon: ShoppingCart },
      { to: "/perfil/seguridad", label: t("nav.security"), icon: ShieldCheck },
    ],
  };
}

function buildOpsNav() {
  return {
    corporate_admin: [
      // Fix WH19 (2026-08-31): este menú tenía 36 entradas planas, sin una sola
      // división. Es la causa literal de dos puntos del video de Claudia (25/08):
      //   · E4 (min 10:17) "panel de finanzas y panel de operación separados"
      //   · D1 (min 11:02) "Mis KPIs, Mis bonos, Tablero, Captura — tengo muchas
      //     dudas, no entiendo qué es cada rubro"
      // Ninguno de los dos era un problema de las pantallas: eran un problema de
      // cómo se llega a ellas. Agrupar el menú los resuelve sin tocar ni una
      // pantalla, sin mover ninguna ruta y sin cambiar ningún permiso.
      // El campo `section` es OPCIONAL: los ítems que no lo llevan se dibujan
      // exactamente como hoy.
      { to: "/ops", label: "Panel general", icon: LayoutGrid },

      { to: "/ops/cortes", label: "Cortes de caja", icon: ReceiptText, section: "Finanzas" },
      { to: "/ops/conciliacion", label: "Conciliacion", icon: Shuffle, section: "Finanzas" },
      { to: "/ops/faltantes", label: "Faltantes", icon: SearchX, section: "Finanzas" },
      // Fix WH75 (2026-10-13): "Bancos" (Syncfy) sale del menu. La conciliacion de pagos
      // a proveedores ahora se hace subiendo a mano el archivo de transferencias de BBVA
      // Net Cash. La ruta vieja /ops/bancos redirige a la pantalla nueva.
      { to: "/ops/pagos-banco", label: "Pagos del banco", icon: Landmark, section: "Finanzas" },
      { to: "/ops/cash-flow", label: "Flujo de caja", icon: Banknote, section: "Finanzas" },
      { to: "/ops/analisis", label: "Analisis ventas", icon: ChartLine, section: "Finanzas" },
      { to: "/ops/reportes", label: "Reportes", icon: BarChart3, section: "Finanzas" },
      { to: "/ops/fiscal", label: "Fiscal CFDI 4.0", icon: FileText, section: "Finanzas" },
      // Fix WH46 (2026-09-11): contabilidad —Janeth Puente— esta cargada como
      // corporativo, asi que el renglon de ordenes de compra YA lo tenia en el
      // menu de Compras. Pero trabaja del lado de Ops (fiscal, cortes,
      // conciliacion), y desde ahi no se ve. Mismo motivo que en tesoreria: el
      // acceso estaba, faltaba el camino.
      { to: "/ocs", label: "Ordenes de compra", icon: ShoppingCart, section: "Finanzas" },

      { to: "/ops/checklists", label: "Checklists", icon: ClipboardList, section: "Operacion" },
      // Fix WH36 (2026-09-08): había dos cosas distintas y el nombre las confundía.
      // "Limpieza" apuntaba a /ops/limpieza — las rondas por hora, con tareas que
      // no salen de ningún documento de Chizy — mientras que los tres protocolos
      // que mandó Claudia (pre-apertura, post-cierre y plan semanal) viven en
      // Checklists, categoría Limpieza. Ahora cada entrada dice lo que es.
      { to: "/ops/checklists?category=limpieza", label: "Protocolos de limpieza", icon: SprayCan, section: "Operacion" },
      { to: "/ops/limpieza", label: "Rondas por hora", icon: SprayCan, section: "Operacion" },
      // Fix WH42 (2026-09-09): pedido de Gabriela — registrar la merma real.
      { to: "/ops/mermas", label: "Merma", icon: Trash2, section: "Operacion" },
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench, section: "Operacion" },
      { to: "/ops/vigencias", label: "Vigencias", icon: CalendarCheck2, section: "Operacion" },
      { to: "/ops/viaticos", label: "Viaticos", icon: Wallet, section: "Operacion" },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true, section: "Operacion" },
      { to: "/ops/predicciones", label: "Predicciones", icon: TrendingUp, section: "Operacion" },

      { to: "/ops/kpis", label: "Mis KPIs", icon: TrendingUp, kpiBadge: true, section: "KPIs" },
      { to: "/ops/kpis/mi-bono", label: "Mi bono", icon: Coins, section: "KPIs" },
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target, section: "KPIs" },
      { to: "/ops/kpis/captura", label: "Captura RH de KPIs", icon: ClipboardEdit, section: "KPIs" },
      { to: "/ops/admin/kpis/catalogo", label: "Catálogo de KPIs", icon: BarChart3, section: "KPIs" },
      { to: "/ops/admin/kpis/revisar-propuestas", label: "Revisar propuestas", icon: Sparkles, proposalsBadge: true, section: "KPIs" },
      { to: "/ops/admin/kpis/wizard-configuracion", label: "Wizard de fórmulas", icon: Wand2, section: "KPIs" },

      { to: "/ops/rrhh/empleados", label: "Colaboradores", icon: UserSquare2, section: "Personas" },
      { to: "/ops/rrhh/bajas", label: "Bajas", icon: UserMinus2, section: "Personas" },
      { to: "/ops/rrhh/vacaciones", label: "Vacaciones", icon: CalendarCheck2, section: "Personas" },
      { to: "/ops/rrhh/nomina", label: "Nomina", icon: Briefcase, section: "Personas" },

      { to: "/ops/admin/checklists", label: "Checklists (admin)", icon: ListChecks, section: "Administracion" },
      { to: "/ops/admin/cleaning-rotations", label: "Rotaciones limpieza", icon: SprayCan, section: "Administracion" },
      { to: "/ops/admin/solicitudes/reglas", label: "Reglas de aprobación", icon: ShieldAlert, section: "Administracion" },
      { to: "/ops/admin/legal-entities", label: "Razones sociales", icon: Building2, section: "Administracion" },
      { to: "/admin/sucursales", label: "Sucursales", icon: Store, section: "Administracion" },
      { to: "/usuarios", label: "Usuarios", icon: UserCog, section: "Administracion" },
      { to: "/ops/admin/config", label: "Configuracion", icon: Settings, section: "Administracion" },
      { to: "/admin/system-flags", label: "Flags del sistema", icon: ToggleRight, section: "Administracion" },
      { to: "/admin/codigo-fuente", label: "Código fuente", icon: FileArchive, section: "Administracion" },

      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    direccion: [
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target },
      { to: "/ops/kpis/scorecard/dashboards", label: "Dashboards Scorecard", icon: BarChart3 },
      { to: "/ops/checklists", label: "Checklists (torre de control)", icon: ListChecks },
      { to: "/ops/rrhh/empleados", label: "Colaboradores", icon: UserSquare2 },
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true },
      { to: "/alertas", label: "Alertas", icon: Bell },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    hr_admin: [
      // Fix WH19 (2026-08-31): mismas secciones que corporativo, con lo que ve RH.
      { to: "/ops", label: "Panel general", icon: LayoutGrid },

      { to: "/ops/kpis", label: "Mis KPIs", icon: TrendingUp, kpiBadge: true, section: "KPIs" },
      { to: "/ops/kpis/mi-bono", label: "Mi bono", icon: Coins, section: "KPIs" },
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target, section: "KPIs" },
      { to: "/ops/kpis/captura", label: "Captura RH de KPIs", icon: ClipboardEdit, section: "KPIs" },
      { to: "/ops/admin/kpis/catalogo", label: "Catálogo de KPIs", icon: BarChart3, section: "KPIs" },
      { to: "/ops/admin/kpis/revisar-propuestas", label: "Revisar propuestas", icon: Sparkles, proposalsBadge: true, section: "KPIs" },
      { to: "/ops/admin/kpis/wizard-configuracion", label: "Wizard de fórmulas", icon: Wand2, section: "KPIs" },

      { to: "/ops/rrhh/empleados", label: "Colaboradores", icon: UserSquare2, section: "Personas" },
      { to: "/ops/rrhh/bajas", label: "Bajas", icon: UserMinus2, section: "Personas" },
      { to: "/ops/rrhh/vacaciones", label: "Vacaciones", icon: CalendarCheck2, section: "Personas" },
      { to: "/ops/rrhh/nomina", label: "Nomina", icon: Briefcase, section: "Personas" },

      { to: "/ops/checklists", label: "Checklists", icon: ListChecks, section: "Operacion" },
      { to: "/ops/admin/checklists/reportes", label: "Reporte de checklists", icon: BarChart3, section: "Operacion" },
      { to: "/ops/viaticos", label: "Viaticos", icon: Wallet, section: "Operacion" },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true, section: "Operacion" },
      { to: "/proveedores", label: "Revision legal", icon: Scale, section: "Operacion" },

      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    colaborador: [
      { to: "/ops/portal", label: "Mi portal", icon: LayoutGrid },
      { to: "/ops/portal/mis-recibos", label: "Mis recibos", icon: FileText },
      { to: "/ops/portal/mi-asistencia", label: "Mi asistencia", icon: Calendar },
      { to: "/ops/portal/mis-vacaciones", label: "Mis vacaciones", icon: CalendarCheck2 },
      { to: "/ops/portal/mis-datos", label: "Mis datos", icon: UserSquare2 },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    treasury: [
      // Fix WH19 (2026-08-31): Tesoreria es el caso mas claro de E4 — su menu es
      // casi todo finanzas, y las tres pantallas de operacion se le perdian entre
      // medio. Ahora estan separadas.
      { to: "/ops", label: "Panel general", icon: LayoutGrid },

      { to: "/ops/cortes", label: "Cortes de caja", icon: ReceiptText, section: "Finanzas" },
      { to: "/ops/conciliacion", label: "Conciliacion", icon: Shuffle, section: "Finanzas" },
      { to: "/ops/faltantes", label: "Faltantes", icon: SearchX, section: "Finanzas" },
      // Fix WH75 (2026-10-13): "Bancos" (Syncfy) sale del menu. La conciliacion de pagos
      // a proveedores ahora se hace subiendo a mano el archivo de transferencias de BBVA
      // Net Cash. La ruta vieja /ops/bancos redirige a la pantalla nueva.
      { to: "/ops/pagos-banco", label: "Pagos del banco", icon: Landmark, section: "Finanzas" },
      { to: "/ops/cash-flow", label: "Flujo de caja", icon: Banknote, section: "Finanzas" },
      { to: "/ops/analisis", label: "Analisis ventas", icon: ChartLine, section: "Finanzas" },
      { to: "/ops/reportes", label: "Reportes", icon: BarChart3, section: "Finanzas" },
      { to: "/ops/fiscal", label: "Fiscal CFDI 4.0", icon: FileText, section: "Finanzas" },
      // Fix WH46 (2026-09-11): el renglon va tambien aca, y no solo en el menu de
      // Compras, porque tesoreria trabaja casi todo el dia del lado de Ops
      // —cortes, conciliacion, fiscal— y desde ahi el menu es otro. Obligarlas a
      // saber que existe un boton "Compras" arriba para conciliar una factura es
      // pedirles que conozcan como esta partido el sistema por dentro. El
      // precedente ya existe: el menu de Ops de legal tiene "Revision legal", que
      // tambien vive del lado de Compras.
      { to: "/ocs", label: "Ordenes de compra", icon: ShoppingCart, section: "Finanzas" },

      { to: "/ops/viaticos", label: "Viaticos", icon: Wallet, section: "Operacion" },
      { to: "/ops/vigencias", label: "Vigencias", icon: CalendarCheck2, section: "Operacion" },
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench, section: "Operacion" },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true, section: "Operacion" },
      { to: "/ops/predicciones", label: "Predicciones", icon: TrendingUp, section: "Operacion" },

      { to: "/ops/kpis", label: "Mis KPIs", icon: TrendingUp, kpiBadge: true, section: "KPIs" },
      { to: "/ops/kpis/mi-bono", label: "Mi bono", icon: Coins, section: "KPIs" },
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target, section: "KPIs" },

      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    branch_manager: [
      { to: "/ops", label: "Panel general", icon: LayoutGrid },
      { to: "/ops/kpis", label: "Mis KPIs", icon: TrendingUp, kpiBadge: true },
      { to: "/ops/kpis/mi-bono", label: "Mi bono", icon: Coins },
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target },
      { to: "/ops/checklists", label: "Mis checklists", icon: ClipboardList },
      // Fix WH36 (2026-09-08): ver comentario en el menú de corporativo.
      { to: "/ops/checklists?category=limpieza", label: "Protocolos de limpieza", icon: SprayCan },
      { to: "/ops/limpieza", label: "Rondas por hora", icon: SprayCan },
      { to: "/ops/cortes", label: "Cortes de caja", icon: ReceiptText },
      { to: "/ops/vigencias", label: "Vigencias", icon: CalendarCheck2 },
      { to: "/ops/viaticos", label: "Viaticos", icon: Wallet },
      // Fix WH42 (2026-09-09): la merma la carga quien la ve.
      { to: "/ops/mermas", label: "Merma", icon: Trash2 },
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench },
      { to: "/ops/predicciones", label: "Predicciones", icon: TrendingUp },
      { to: "/ops/rrhh/empleados", label: "Colaboradores", icon: UserSquare2 },
      { to: "/ops/rrhh/vacaciones", label: "Vacaciones", icon: CalendarCheck2 },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    legal: [
      { to: "/ops/vigencias", label: "Vigencias", icon: CalendarCheck2 },
      // Fix WH64 (2026-09-28): empresas titulares de marcas y demás razones sociales.
      { to: "/ops/admin/legal-entities", label: "Razones sociales", icon: Building2 },
      { to: "/ops/kpis", label: "Mis KPIs", icon: TrendingUp, kpiBadge: true },
      { to: "/ops/kpis/mi-bono", label: "Mi bono", icon: Coins },
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target },
      { to: "/proveedores", label: "Revision legal", icon: Scale },
      { to: "/alertas", label: "Alertas", icon: Bell },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    operativo: [
      { to: "/ops/kpis/scorecard", label: "Tablero de KPIs", icon: Target },
      { to: "/ops/checklists", label: "Mis checklists", icon: ClipboardList },
      // Fix WH36 (2026-09-08): ver comentario en el menú de corporativo.
      { to: "/ops/checklists?category=limpieza", label: "Protocolos de limpieza", icon: SprayCan },
      { to: "/ops/limpieza", label: "Rondas por hora", icon: SprayCan },
      // Fix WH42 (2026-09-09): la merma la carga quien la ve, desde el celular.
      { to: "/ops/mermas", label: "Merma", icon: Trash2 },
      // Fix WH13 (2026-08-30): la sucursal levanta las solicitudes de mantenimiento
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true },
      { to: "/perfil/seguridad", label: "Mi perfil", icon: ShieldCheck },
    ],
    mantenimiento: [
      { to: "/ops/mantenimientos", label: "Mantenimientos", icon: Wrench },
      { to: "/ops/mantenimientos/proveedores", label: "Proveedores", icon: Users },
      { to: "/ops/solicitudes", label: "Solicitudes", icon: Inbox, requestsBadge: true },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
    sistemas: [
      { to: "/ops/kpis", label: "Mis KPIs", icon: TrendingUp, kpiBadge: true },
      { to: "/ops/kpis/mi-bono", label: "Mi bono", icon: Coins },
      { to: "/ops/viaticos", label: "Viaticos", icon: Wallet },
      { to: "/perfil/seguridad", label: "Seguridad", icon: ShieldCheck },
    ],
  };
}

// Roles that can switch between Compras and Ops platforms
const OPS_CAPABLE_ROLES = ["corporate_admin", "treasury", "branch_manager", "sistemas", "legal"];
// Ruta de entrada a Ops por rol (algunos roles OPS_CAPABLE no tienen acceso a "/ops" mismo)
const OPS_ENTRY_ROUTE_BY_ROLE = { sistemas: "/ops/kpis", legal: "/ops/vigencias" };
// Roles que viven solo en Ops (no ven toggle de plataforma)
const OPS_ONLY_ROLES = ["operativo", "hr_admin", "colaborador", "mantenimiento"];

export default function Sidebar() {
  const { user, logout, refreshUser } = useAuth();
  const { t } = useTranslation();
  const roleLabel = useRoleLabel();
  const navigate = useNavigate();
  const location = useLocation();
  const [kpiPendingCount, setKpiPendingCount] = useState(0);
  const [kpiProposalsCount, setKpiProposalsCount] = useState(0);
  const [requestsPendingCount, setRequestsPendingCount] = useState(0);

  const KPI_BADGE_ROLES = ["corporate_admin", "branch_manager", "treasury", "legal", "hr_admin", "sistemas"];
  const KPI_PROPOSALS_BADGE_ROLES = ["corporate_admin", "hr_admin"];

  const fetchKpiCount = useCallback(async () => {
    if (!user || !KPI_BADGE_ROLES.includes(user.role)) return;
    try {
      const res = await api.get("/ops/kpis/my-pending");
      setKpiPendingCount(res.data.total_pending || 0);
    } catch {
      setKpiPendingCount(0);
    }
  }, [user]);

  const fetchKpiProposalsCount = useCallback(async () => {
    if (!user || !KPI_PROPOSALS_BADGE_ROLES.includes(user.role)) return;
    try {
      const res = await api.get("/ops/admin/kpis/pending-confirmation");
      setKpiProposalsCount(res.data.count || 0);
    } catch {
      setKpiProposalsCount(0);
    }
  }, [user]);

  const fetchRequestsPendingCount = useCallback(async () => {
    if (!user || !["corporate_admin", "direccion", "hr_admin", "colaborador", "treasury", "branch_manager", "operativo", "mantenimiento"].includes(user.role)) return;
    try {
      const res = await api.get("/ops/requests/pending-approval");
      setRequestsPendingCount(res.data.total_pending || 0);
    } catch {
      setRequestsPendingCount(0);
    }
  }, [user]);

  useEffect(() => {
    const isOps = location.pathname.startsWith("/ops");
    if (isOps) { fetchKpiCount(); fetchKpiProposalsCount(); fetchRequestsPendingCount(); }
  }, [location.pathname, fetchKpiCount, fetchKpiProposalsCount, fetchRequestsPendingCount]);

  useEffect(() => {
    window.addEventListener("kpi-updated", fetchKpiCount);
    return () => window.removeEventListener("kpi-updated", fetchKpiCount);
  }, [fetchKpiCount]);

  if (!user) return null;

  const isOpsPath = location.pathname.startsWith("/ops");
  const isOpsPlatform = isOpsPath || user.role === "operativo" || user.role === "hr_admin" || user.role === "colaborador";
  const hasOpsSwitch = OPS_CAPABLE_ROLES.includes(user.role);

  const comprasNav = buildComprasNav(t)[user.role] || [];
  const opsNavMap = buildOpsNav();
  const opsNav = opsNavMap[user.role] || [];
  const items = isOpsPlatform ? opsNav : comprasNav;

  const replayTour = () => {
    navigate("/bienvenida-proveedor");
    api.post("/auth/reset-tutorial-flag").then(() => refreshUser()).catch(() => {});
  };

  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex flex-col w-64 h-screen sticky top-0 bg-white border-r border-slate-200 px-4 py-5"
    >
      {/* Logo */}
      <div
        data-testid="sidebar-logo"
        className="flex items-center gap-2.5 px-2 py-2 mb-4 cursor-pointer group"
        onClick={() => navigate(user.role === "operativo" ? "/ops/checklists" : "/dashboard")}
      >
        <motion.div
          whileHover={{ rotate: 30 }}
          transition={{ duration: 0.4 }}
          className="w-9 h-9 rounded-xl bg-[#FFDF00] flex items-center justify-center"
        >
          <Pizza className="w-5 h-5 text-[#1A1A1A]" strokeWidth={2.5} />
        </motion.div>
        <div className="leading-tight">
          <div className="font-display font-extrabold text-[#1A1A1A] text-base">Chizy Chiz</div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">
            {isOpsPlatform ? "Ops" : t("nav.procurement")}
          </div>
        </div>
      </div>

      {/* Platform toggle — only for capable roles */}
      {hasOpsSwitch && (
        <div className="flex rounded-xl border border-slate-200 overflow-hidden mb-4 text-xs font-semibold" data-testid="platform-toggle">
          <button
            onClick={() => navigate("/dashboard")}
            className={`flex-1 py-2 transition-colors ${!isOpsPlatform ? "bg-[#FFDF00] text-slate-900" : "text-slate-500 hover:bg-slate-50"}`}
            data-testid="platform-toggle-compras"
          >
            Compras
          </button>
          <button
            onClick={() => navigate(OPS_ENTRY_ROUTE_BY_ROLE[user.role] || "/ops")}
            className={`flex-1 py-2 transition-colors ${isOpsPlatform ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-50"}`}
            data-testid="platform-toggle-ops"
          >
            Ops
          </button>
        </div>
      )}

      {/* Nav items */}
      {/* Fix WH19 (2026-08-31): encabezado de seccion cuando el item declara
          `section` y es distinta a la del item anterior. Los menus que NO
          declaran `section` (proveedor, legal, operativo, mantenimiento,
          colaborador, sistemas, direccion, branch_manager y TODO el menu de
          Compras) se dibujan exactamente igual que antes: ningun encabezado,
          mismo orden, mismos data-testid. */}
      <nav className="flex-1 flex flex-col gap-1 overflow-y-auto pl-2">
        {items.map((item, idx) => (
          <Fragment key={item.to}>
            {item.section && item.section !== (items[idx - 1] || {}).section && (
              <div
                className="px-2 pt-4 pb-1 text-[10px] font-bold uppercase tracking-widest text-slate-400 select-none"
                data-testid={`nav-section-${item.section.toLowerCase()}`}
              >
                {item.section}
              </div>
            )}
            <NavLink
              to={item.to}
              data-testid={`nav-${item.to.replace(/\//g, "-").replace(/^-/, "")}`}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? "active" : ""}`
              }
            >
              <item.icon className="w-4 h-4" strokeWidth={2.2} />
              <span className="flex-1">{item.label}</span>
              {item.kpiBadge && kpiPendingCount > 0 && (
                <span className="text-xs font-bold bg-red-500 text-white rounded-full px-1.5 py-0.5 min-w-[20px] text-center leading-none" data-testid="sidebar-kpi-badge">
                  {kpiPendingCount}
                </span>
              )}
              {item.proposalsBadge && kpiProposalsCount > 0 && (
                <span className="text-xs font-bold bg-purple-500 text-white rounded-full px-1.5 py-0.5 min-w-[20px] text-center leading-none" data-testid="sidebar-kpi-proposals-badge">
                  {kpiProposalsCount}
                </span>
              )}
              {item.requestsBadge && requestsPendingCount > 0 && (
                <span className="text-xs font-bold bg-red-500 text-white rounded-full px-1.5 py-0.5 min-w-[20px] text-center leading-none" data-testid="sidebar-requests-badge">
                  {requestsPendingCount}
                </span>
              )}
            </NavLink>
          </Fragment>
        ))}
      </nav>

      {/* Footer */}
      <div className="mt-4 pt-4 border-t border-slate-200">
        <div className="px-2 mb-2">
          <div className="text-sm font-semibold text-[#1A1A1A] truncate">{user.full_name}</div>
          <div className="text-xs text-slate-500">{roleLabel(user.role)}</div>
        </div>
        {user.role === "supplier" && (
          <button
            data-testid="sidebar-replay-tour-btn"
            onClick={replayTour}
            className="sidebar-link w-full text-left"
          >
            <PlayCircle className="w-4 h-4" strokeWidth={2.2} />
            <span>{t("tour.replayButton")}</span>
          </button>
        )}
        <button
          data-testid="sidebar-logout-btn"
          onClick={logout}
          className="sidebar-link w-full text-left"
        >
          <LogOut className="w-4 h-4" strokeWidth={2.2} />
          <span>{t("nav.logout")}</span>
        </button>
      </div>
    </aside>
  );
}
